import { ReactNode, useState } from "react";

import ParanoidMode from "../../modules/paranoid-mode/ParanoidMode";
import useParanoidMode from "../../modules/paranoid-mode/hooks/useParanoidMode";
import Typography from "../typography/Typography";
import ModalWrapper from "../ModalWrapper";
import RenderWhen from "../RenderWhen";
import { Icon } from "..";
import styles from "./classification-reason.module.scss";

type Props = {
  icon?: ReactNode;
  label?: ReactNode;
  title: ReactNode;
  showHelp?: boolean;
  onClick?: () => void;
};

const ClassificationReason = ({
  icon,
  label,
  title,
  showHelp,
  onClick
}: Props) => {
  const [show, setShow] = useState<boolean>(false);
  const { paranoidModeConfig, enabledComponents } = useParanoidMode();
  return (
    <RenderWhen condition={!!paranoidModeConfig}>
      <section
        data-testid="report_summary_classification_reason_container"
        className={styles.classification_reason_wrapper}
        onClick={onClick}
      >
        <div className={styles.classification_reason}>
          {icon}
          <Typography
            variant="h5"
            tag="span"
            className={styles.classification_reason_title}
            data-testid="report_summary_classification_reason_title"
          >
            {title}
          </Typography>
        </div>
        <Typography
          tag="span"
          variant="body4"
          className={styles.classification_reason_source}
          data-testid="report_summary_classification_reason_source"
        >
          <>
            {label}
            {showHelp && (
              <span
                className={styles.risk_tolerance_help_container}
                onClick={e => {
                  e.stopPropagation();
                  setShow(true);
                }}
              >
                <Icon
                  className={styles.risk_tolerance_help_icon}
                  name="help"
                  data-testid="risk_tolerance_tooltip_trigger"
                />
              </span>
            )}
          </>
        </Typography>
      </section>
      <ModalWrapper
        title="Risk Tolerance Levels"
        data-testid="risk-tolerance-levels-display"
        show={show}
        onHide={() => setShow(false)}
        size={"xxl" as never}
      >
        <ParanoidMode
          currentLevel={paranoidModeConfig?.level || 0}
          enabledComponents={enabledComponents}
        />
      </ModalWrapper>
    </RenderWhen>
  );
};

export default ClassificationReason;
